<mat-form-field class="w-100">
  @if (helpText) {
    <app-help-text [dataContext]="helpText"></app-help-text>
  }
  <input
    matInput
    [placeholder]="control.caption | translate"
    autocomplete="off"
    [formControl]="control"
    [required]="control.required ? true : null"
    [readonly]="control.isReadonly ? true : null"
    type="number"
    />
    @if (errorMessage) {
      <mat-error>{{ errorMessage.message | translate: errorMessage.params }}</mat-error>
    }
  </mat-form-field>
